// noinspection JSUnresolvedReference

(function ($) {
	'use strict';

	$(document).ready(function () {

		/* Menu fixed */

		$(window).on('scroll', function () {

			if ($(window).scrollTop() > 80) {
				$('.navbar').addClass('fixed');
			} else {
				$('.navbar').removeClass('fixed');
			}
			if ($(window).scrollTop() > 400) {
				$('.navbar').addClass('sm');
			} else {
				$('.navbar').removeClass('sm');
			}
		});

		/* Scroll to */

		$('a[href*="#"]')
			.not('.back-to-top')
			.click(function () {
				let $this = $(this);
				let target = $('#' + getHashFromUrl($this.attr('href')));

				if (target.length) {
					scroll_to(target);
				} else {
					window.location = $this.attr('href');
				}
				return false;
			});

		function getHashFromUrl (url) {

			if (url.indexOf('#') > 0) {
				return $("<a/>").attr("href", url)[0].hash.replace(/^#/, "");
			}
		}

		function scroll_to (target) {

			let $target = $(target);

			if ($target.length) {
				$('html, body').animate({
					scrollTop: $target.offset().top
				}, 500, function () {
					$target.focus();
					if ($target.is(':focus')) {
						return false;
					} else {
						$target.attr('tabindex', '-1');
						$target.focus();
					}
				});
			}
		}

		/* Back to top */

		let offset = 500,
			duration = 500;
		$(window).on('load scroll', function () {
			if ($(window).scrollTop() > offset) {
				$('.back-to-top').removeClass('hidden').addClass('visible');
			} else {
				$('.back-to-top').removeClass('visible').addClass('hidden');
			}
		});

		$('.back-to-top').on('click', function () {
			$('html, body').animate({
				scrollTop: 0,
			}, duration);
			return false;
		});

		/* Dropdown-Menü */

		$('.dropdown').on('hover', function () {
			$(this).addClass('show');
			$(this).find('.dropdown-menu').addClass('show');
		}, function () {
			$(this).removeClass('show');
			$(this).find('.dropdown-menu').removeClass('show');
		});

		$('.dropdown-btn').on('click', function (e) {
			let $this = $(this);
			let submenu = $this.siblings('.dropdown-menu');

			if ($this.hasClass('active')) {
				$this.removeClass('active');
				submenu.removeClass('show');
			} else {
				$(this).addClass('active');
				submenu.addClass('show');
			}
			e.preventDefault();
		});

		/* Map */

		let cookie = Cookies.get('maps_allowed');
		let mapPlaceholder = $('.map-placeholder');

		if (cookie) {
			activateMaps();
		} else {
			mapPlaceholder.removeClass('d-none');
		}

		$('#map-privacy-check').on('click', function() {
			activateMaps();
			Cookies.set('maps_allowed');
		});

		function activateMaps() {
			let mapContainer = '<div id="map"></div>';
			mapPlaceholder.after(mapContainer);
			mapPlaceholder.hide();

			if ($('#map').length > 0) {
				activateMap();
			}
		}

		/* Sonstige */

		$('a.nolink').on('click', function (e) {
			e.preventDefault();
		});

		/* Plugins */

		/*$('.parallax').parallax({
			imageSrc: 'files/theme/images/parallax-01.jpg'
		});*/

	});
})(jQuery);